import React from "react";
import {Select} from "antd";
import {useFetch} from "hooks/useFetch";
import {useStore} from "hooks/useStore";
import {arrayAlphabeticalSort} from "utils/helpers";
import {normalizeStringSearchFilter} from "utils/helpers";

const CityInput = ({value, onChange, optionMappingKey = "_id", ...props}) => {
    const stores = useStore();
    const [cityLoading, cities] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.optionStore.loadCities.bind(null),
        initialCall: true,
        dependencies: []
    });

    return (
        <Select
            value={value}
            allowClear
            showSearch
            style={{width: "100%"}}
            loading={cityLoading}
            data-testid="cityInput"
            onChange={onChange}
            filterOption={(input, option) =>
                normalizeStringSearchFilter(option?.children ?? "").includes(
                    normalizeStringSearchFilter(input)
                )
            }
            {...props}
        >
            {arrayAlphabeticalSort(cities, "name")?.map(city => (
                <Select.Option
                    key={city?.[optionMappingKey]}
                    value={city?.[optionMappingKey]?.toLocaleLowerCase("tr-TR")}
                    data-testid="cityInput_option"
                >
                    {city?.name}
                </Select.Option>
            ))}
        </Select>
    );
};

export default CityInput;
